<template>
	<div class="program-monitor ml-12 mr-12">
		<span>
			<label class="program-monitor-placeholder-input">{{$t('Video Input')}}</label>
			<multiselect class="program-monitor-input" v-model="valueVideo" deselect-label="Can't remove this value"
			track-by="label" label="label" @select="onSelect" placeholder=" "
			:options="videoOptions" :searchable="false" :allow-empty="false" :show-labels="false">
			<span class="arrow-multiselect" slot="caret">
				<i class="material-icons pb-1 mt-1 ml-2 size-arrow">expand_more</i>
			</span>
			<template slot="singleLabel" slot-scope="{ option }">{{ option.label }}</template>
			</multiselect>
		</span>
	</div>
</template>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>


<script>
import RTC from 'detectrtc';
import Multiselect from 'vue-multiselect';

export default {
	name: 'compositionVideoInput',
	components: {
		Multiselect,
	},
	data() {
		return {
			valueVideo: '',
			audioOptions: [],
			videoOptions: [],
			programOptions: [],
			detailsDebug: '',
			activeBtn: '',
		};
	},
	mounted() {
		this.initDevices();
	},
	methods: {
		onSelect(device) {
			this.$emit('selectVideoSource', device);
		},
		initDevices() {
			RTC.load(() => {
				RTC.MediaDevices.map((device) => {
					if (device.kind === 'videoinput') {
						this.videoOptions.push(device);
						this.programOptions.push(device);
					}
					return device;
				});
			});
		},
	},

};
</script>
